<div class="notification-container">
  <div *ngIf="newChatAssigned()"
       class="notification-badge chat-assigned"
       (click)="handleChatAssignmentClick()">
    <i class="fas fa-headset"></i> {{ 'chat.newChat' | translate }}
  </div>
  <div *ngIf="showMessageNotification()"
       class="notification-badge message-notification"
       (click)="handleMessageNotificationClick()">
    <div class="notification-content">
      <i class="fas fa-comment"></i> {{ 'chat.newMassage' | translate }}<br>
      <div *ngIf="!isClient()">
        <span  class="project-name"> {{ 'chat.project' | translate }} : {{ projectName() }}</span><br>
      </div>
      <span class="message-content"> {{ messagePreview() }}</span>
    </div>
  </div>
</div>


